export const APP_NAME = 'Zania Exchange';

export const AUTH = {
  MAX_REDIRECT_ATTEMPTS: 1,
  SESSION_COOKIE_NAME: 'zx_session',
} as const;

export const QUERY_KEYS = {
  authSession: ['auth-session'] as const,
  assessmentRooms: ['assessment-rooms'] as const,
  assessmentDetails: ['assessment-details'] as const,
  roomCategories: (roomId: string) => ['room-categories', roomId] as const,
  chatMessages: (chatId: string) => ['chat-messages', chatId] as const,
  followUpStatus: ['follow-up-status'] as const,
} as const;
